function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconfinderArtificialIntelligence262890587 = function SvgIconfinderArtificialIntelligence262890587(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1_1_",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    d: "M21.286,37.383c-0.261-0.518-0.488-1.056-0.673-1.614L16,35v-6l4.613-0.769    c0.185-0.558,0.412-1.096,0.673-1.614l-2.721-3.809l4.243-4.243l3.809,2.721c0.518-0.261,1.056-0.488,1.614-0.673L29,16h6    l0.769,4.613c0.558,0.185,1.096,0.412,1.614,0.673l3.809-2.721l4.243,4.243l-2.721,3.809c0.261,0.518,0.488,1.056,0.673,1.614    L48,29v6l-4.613,0.769c-0.185,0.558-0.412,1.096-0.673,1.614l2.721,3.809l-4.243,4.243l-3.809-2.721    c-0.518,0.261-1.056,0.489-1.614,0.673L35,48h-6l-0.769-4.613c-0.558-0.185-1.096-0.412-1.614-0.673l-3.809,2.721l-4.243-4.243    L21.286,37.383z",
    style: {
      fill: "#FFCB57"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M32,41c4.962,0,9-4.037,9-9s-4.038-9-9-9s-9,4.037-9,9S27.038,41,32,41z M31,32    c0-0.552,0.449-1,1-1s1,0.448,1,1s-0.449,1-1,1S31,32.552,31,32z M32,25c3.86,0,7,3.141,7,7c0,3.519-2.613,6.432-6,6.92v-4.104    c1.161-0.414,2-1.514,2-2.816c0-1.654-1.346-3-3-3s-3,1.346-3,3c0,1.302,0.839,2.402,2,2.816v4.104c-3.387-0.488-6-3.401-6-6.92    C25,28.141,28.14,25,32,25z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M43.607,26.167l-1.786,0.9c0.248,0.491,0.456,0.989,0.617,1.478l0.189,0.573L47,29.848v4.305    l-4.373,0.729l-0.189,0.573c-0.161,0.488-0.369,0.986-0.617,1.478l-0.272,0.54l2.58,3.611l-3.044,3.045l-3.612-2.58l-0.539,0.271    c-0.493,0.248-0.991,0.456-1.479,0.617l-0.573,0.189L34.153,47h-4.306l-0.729-4.373l-0.573-0.189    c-0.488-0.161-0.986-0.369-1.479-0.617l-0.539-0.271l-3.612,2.58l-3.644-3.644l-1.414,1.414L22.7,46.74l4.02-2.871    c0.207,0.093,0.415,0.18,0.622,0.26L28.153,49h7.694l0.812-4.871c0.207-0.08,0.415-0.167,0.622-0.26l4.02,2.871l5.441-5.439    L43.87,37.28c0.093-0.207,0.18-0.414,0.26-0.622L49,35.848v-7.695l-4.87-0.811C43.978,26.949,43.803,26.556,43.607,26.167z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M15,28.152v7.695l4.87,0.811c0.152,0.393,0.327,0.786,0.523,1.175l1.786-0.9    c-0.248-0.491-0.456-0.989-0.617-1.478l-0.189-0.573L17,34.152v-4.305l4.373-0.729l0.189-0.573    c0.161-0.488,0.369-0.986,0.617-1.478l0.272-0.54l-2.58-3.611l3.044-3.045l3.612,2.58l0.54-0.272    c0.487-0.246,0.984-0.453,1.478-0.616l0.573-0.189L29.847,17h4.306l0.729,4.373l0.573,0.189c0.494,0.163,0.991,0.37,1.478,0.616    l0.54,0.272l3.612-2.58l3.644,3.644l1.414-1.414L41.3,17.258l-4.02,2.872c-0.207-0.093-0.414-0.179-0.622-0.26L35.847,15h-7.694    l-0.812,4.87c-0.208,0.081-0.416,0.167-0.622,0.26l-4.02-2.872l-5.441,5.441l2.872,4.021c-0.093,0.207-0.18,0.414-0.26,0.622    L15,28.152z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 31,
    y: 19
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.7401 23.5146)",
    width: 2,
    x: 22.515,
    y: 22.515
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 19,
    y: 31
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -21.7402 28.4853)",
    width: 2,
    x: 22.515,
    y: 39.485
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 31,
    y: 43
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.7696 40.4854)",
    width: 2,
    x: 39.485,
    y: 39.485
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    width: 2,
    x: 43,
    y: 31
  }), React.createElement("rect", {
    height: 2,
    style: {
      fill: "#464ee5"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -4.7695 35.5147)",
    width: 2,
    x: 39.485,
    y: 22.515
  }), React.createElement("path", {
    d: "M62.97,31.758C62.918,31.55,57.486,11,32,11S1.082,31.55,1.03,31.758L0.969,32l0.061,0.242    C1.082,32.45,6.514,53,32,53s30.918-20.55,30.97-20.758L63.031,32L62.97,31.758z M3.038,32.005    c0.522-1.733,4.22-12.446,16.649-16.98C14.435,18.846,11,25.022,11,32c0,7.025,3.479,13.239,8.793,17.054    C7.176,44.594,3.572,33.859,3.038,32.005z M32,13c10.477,0,19,8.523,19,19s-8.523,19-19,19s-19-8.523-19-19S21.523,13,32,13z     M44.313,48.975C49.565,45.154,53,38.978,53,32c0-7.025-3.479-13.239-8.793-17.054c12.617,4.46,16.22,15.195,16.754,17.049    C60.44,33.729,56.742,44.441,44.313,48.975z",
    style: {
      fill: "#464ee5"
    }
  })), React.createElement("g", null, React.createElement("path", {
    d: "M31,58c0,0.552-0.449,1-1,1H13.816c-0.414-1.161-1.514-2-2.816-2c-1.654,0-3,1.346-3,3s1.346,3,3,3    c1.302,0,2.402-0.839,2.816-2H30c1.654,0,3-1.346,3-3v-3h-2V58z M11,61c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1    S11.551,61,11,61z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M11,54c1.654,0,3-1.346,3-3v-1h-2v1c0,0.552-0.449,1-1,1H6.816C6.402,50.839,5.302,50,4,50    c-1.654,0-3,1.346-3,3s1.346,3,3,3c1.302,0,2.402-0.839,2.816-2H11z M4,54c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1    S4.551,54,4,54z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M60,8c-1.302,0-2.402,0.839-2.816,2H53c-1.654,0-3,1.346-3,3v1h2v-1c0-0.552,0.449-1,1-1h4.184    c0.414,1.161,1.514,2,2.816,2c1.654,0,3-1.346,3-3S61.654,8,60,8z M60,12c-0.551,0-1-0.448-1-1s0.449-1,1-1s1,0.448,1,1    S60.551,12,60,12z",
    style: {
      fill: "#464ee5"
    }
  }), React.createElement("path", {
    d: "M53,7c1.654,0,3-1.346,3-3s-1.346-3-3-3c-1.302,0-2.402,0.839-2.816,2H34c-1.654,0-3,1.346-3,3v3h2    V6c0-0.552,0.449-1,1-1h16.184C50.598,6.161,51.698,7,53,7z M53,3c0.551,0,1,0.448,1,1s-0.449,1-1,1s-1-0.448-1-1S52.449,3,53,3z",
    style: {
      fill: "#464ee5"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconfinderArtificialIntelligence262890587, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iconfinder_ArtificialIntelligence26_2890587.c20b9036.svg";
export { ForwardRef as ReactComponent };